import { Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TimelineEventDot from '../TimelineEventDot';
import TimelineLink from '../TimelineLink';
import StatusPill from '../StatusPill';
import { formatDate } from '../../../utils/dateUtils';
import { COLORS, TYPOGRAPHY, SPACING } from '../../../constants/theme';

const { Text } = Typography;

const ApplicationEvent = ({ application, date }) => {
  const history = useHistory();
  const company = useSelector((state) => state.user.currentUser.company);
  const jobTitle = application.job?.title || 'Unknown Position';

  return {
    dot: <TimelineEventDot icon={FileTextOutlined} backgroundColor={COLORS.TIMELINE_APPLICATION} />,
    color: '#434343',
    children: (
      <div style={{ paddingBottom: SPACING.LG, marginLeft: SPACING.SM }}>
        <div style={{ marginBottom: '4px' }}>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM }}>
            Applied to
          </Text>
          {application.job?.id ? (
            <TimelineLink
              href={`/jobs/${application.job.id}`}
              onClick={() => history.push(`/jobs/${application.job.id}`)}
              style={{ marginLeft: '4px' }}
            >
              {jobTitle}
            </TimelineLink>
          ) : (
            <Text strong style={{ fontSize: TYPOGRAPHY.FONT_SIZES.MD, color: '#262626', marginLeft: '4px' }}>
              {jobTitle}
            </Text>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACING.SM, flexWrap: 'wrap' }}>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM }}>
            {formatDate(date || application.atsApplicationDate)}
          </Text>
          {application.applicationStatus && application.applicationStatus !== '-' && (
            <StatusPill status={application.applicationStatus} company={company} />
          )}
        </div>
      </div>
    ),
  };
};

export default ApplicationEvent;
